import React from "react";
import { Backdrop, Fade, Modal } from "@mui/material";
import SoftBox from "components/SoftBox";

import PropTypes from "prop-types";

function MDModal({ open, onClose, width, height, overflow, children }) {
  const style = {
    position: "absolute",
    width: width,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: height || "100vh",
    overflow: overflow ? overflow : "unset",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={onClose}
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <SoftBox sx={style}>{children}</SoftBox>
      </Fade>
    </Modal>
  );
}

MDModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  overflow: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default MDModal;
